import Axios from "axios";
import { API_URL } from "../config";
import storage from "../utils/storage";
import { rememberReturnTo } from "./returnTo";
import { lang, isEnglish, t } from "../i18n";

function authRequestInterceptor(config) {
  const token = storage.getToken();
  if (token) {
    config.headers = {
      ...config.headers,
      authorization: `Bearer ${token}`,
      Accept: "application/json",
      "X-Lang": lang,
    };
  } else {
    config.headers = {
      ...config.headers,
      authorization: `Bearer`,
      Accept: "application/json",
      "X-Lang": lang,
    };
  }
  return config;
}

function authResponseInterceptor(error) {
  // Arabic messages from the server are shown in English when the interface is English.
  const data = error.response && error.response.data;
  if (isEnglish && data && typeof data.message === "string") data.message = t(data.message);

  // Handle 401 Unauthorized responses
  if (error.response && error.response.status === 401) {
    // Clear the token from storage
    storage.clearToken();

    // Redirect to login page
    rememberReturnTo(window.location.pathname + window.location.search);
    window.location.href = "/login";

    return Promise.reject(error);
  }

  return Promise.reject(error);
}

export const axios = Axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use((response) => response, authResponseInterceptor);
